import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ErrorUI } from '../components/UI/Modals/Modals';
import { PostMethod } from '../services/CallApi';
import { CheckValue, sortData } from '../services/CommonFunction';
import { staticVar } from '../services/Constants';
import { setCoach } from '../services/SetApiResponse';
import { userData } from '../services/subscriberService';

const initialState = {
    list: [],
    status: staticVar.idle
};

export const getCoachList =  createAsyncThunk('_getCoach', async (data,{ dispatch, rejectWithValue }) => {
    try {
        const data = {
            gym_id: userData.selectedGym.gym_id,
            only_approved: true
        }
        const response = await PostMethod('_getCoach',data);
        return response.data.data.map(el => (setCoach(el))).sort(sortData);
    } catch (err) {
        if (!err.response) {
            throw err
        }
        if(err.response.data.statusCode === 401) {
            ErrorUI(err.response.data);
        }
        return rejectWithValue({err: err.response.data,id: data.id,updated: data.updated})
    }
});

const coachDataSlice = createSlice({
    name: 'coachData',
    initialState,
    reducers: {
        resetCoach: (state) => {
            state.list = []; 
            state.status = staticVar.idle;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCoachList.pending, (state,action) => {
                state.status = staticVar.loading;
            })
            .addCase(getCoachList.fulfilled, (state,action) => {
                const list = [...state.list];
                if(CheckValue(list)) {
                    action.payload.forEach(element => {
                        list.push(element);
                    });
                    state.list = list;
                }
                state.status = staticVar.idle;
            })
            .addCase(getCoachList.rejected, (state,action) => {
                state.status = staticVar.idle;
                // ErrorUI(action.payload.err);
            })
    }
});

export const getAllCoach = (state) => state.coachData;
export const { resetCoach } = coachDataSlice.actions;
export default coachDataSlice.reducer;